"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Checkbox", {
    enumerable: true,
    get: function() {
        return Checkbox;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useCheckbox = require("./useCheckbox");
const _renderCheckbox = require("./renderCheckbox");
const _useCheckboxStylesstyles = require("./useCheckboxStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Checkbox = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useCheckbox.useCheckbox_unstable)(props, ref);
    (0, _useCheckboxStylesstyles.useCheckboxStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useCheckboxStyles_unstable')(state);
    return (0, _renderCheckbox.renderCheckbox_unstable)(state);
});
Checkbox.displayName = 'Checkbox';
